import React from 'react';
import axios from 'axios'
import { Link } from 'react-router-dom';
import './page.module.css'

class Home extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            search: '',
            homePage: []
        }
    }
    componentDidMount(){
        axios.get('https://www.themealdb.com/api/json/v1/1/filter.php?a=Indian')
        .then(res => 
            // console.log(res.data.meals)
            this.setState({
                homePage: res.data.meals
            })
        )
    }
    render(){
        return(
            <div className="row mb-5">
                <div className="card mb-5" style={{color: "#fb6621", fontFamily: "Kalam , cursive"}}>
                    <img className="" width="100%" src="page-bg.png" alt=" " />
                    {/* <div className="card-img-overlay font-weight-bold" style={{marginLeft: "30%", marginTop: "7%", fontSize: "140px"}}>FIND</div>
                    <div className="card-img-overlay font-weight-bold" style={{marginLeft: "40%", marginTop: "16%", fontSize: "140px"}}>YOUR</div>
                    <div className="card-img-overlay font-weight-bold" style={{marginLeft: "50%", marginTop: "25%", fontSize: "140px"}}>RECIPIE</div> */}
                </div>
                <br/>
                {
                    this.state.homePage && this.state.homePage.map(item => (
                        <div className="col-12 col-sm-6 col-xl-4" key={item.idMeal}>
                            <div className="col my-4">
                                <div className="card mx-auto shadow" style={{width: "24rem"}}>
                                    <img src={item.strMealThumb} className="card-img-top" alt="" />
                                    <div className="card-body" style={{backgroundColor: "#fb6621"}}>
                                        {/* <div className="card-title h4 text-light font-weight-bold">{item.strMeal}</div> */}
                                        <Link id="categoryCard" to={`/${item.idMeal}`}>{item.strMeal}</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        )
    }
}

export default Home